export function OutlineSignoMoneyIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.287 6.84247C15.471 6.39127 14.1126 5.80567 12.4038 5.83927C11.4342 5.85847 9.29825 5.89687 8.44865 7.33687C7.97825 8.13367 7.87265 9.39607 8.44865 10.3369C9.96065 12.8041 14.8518 10.8697 16.3638 13.3369C16.9398 14.2729 16.8342 15.5353 16.3638 16.3369C15.5238 17.7625 13.4502 17.8153 12.543 17.8345C10.3542 17.8921 8.69345 16.8937 7.90625 16.3369"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12.4038 2.84375V5.84375"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12.4038 17.8438V20.8437"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
